import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext"; // 👈 نفس المكان اللي بتجيب منه بيانات المستخدم

// إنشاء السياق
const FeaturesContext = createContext();

// المزوّد (Provider)
export const FeaturesProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated && user?.tenant_featuers) {
      setFeatures(user.tenant_featuers);
      console.log("✅ Features Loaded:", user.tenant_featuers);
    } else {
      setFeatures([]);
    }
    setLoading(false);
  }, [isAuthenticated, user]);

  // دالة مساعدة للتحقق من وجود الميزة
  const hasFeature = (key) => {
    if (!features) return false;
    const feature = features.find((f) => f.key === key);
    return feature && feature.value === "1";
  };

  // دالة لإرجاع تفاصيل ميزة معينة (لو حبيت تستخدمها)
  const getFeature = (key) => {
    return features.find((f) => f.key === key);
  };

  return (
    <FeaturesContext.Provider value={{ features, hasFeature, getFeature, loading }}>
      {children}
    </FeaturesContext.Provider>
  );
};

// Hook مخصص للوصول السريع للسياق
export const useFeatures = () => useContext(FeaturesContext);
